<script lang="ts">

    export let disabled = false;

</script>

<button type="button" on:click {disabled} {...$$props}>
    <slot />
</button>

<style lang="scss">

    button {
        position: relative;
        font-family: ManagerButton;
        line-height: 1.2em;
        padding: 0.75rem 1rem 0.25rem;
        font-size: min(6.5vw, 1.7rem);
        border: none;
        color: var(--color-primary);
        border-radius: 0.25rem;
        background: var(--color-secondary);
        background: linear-gradient(180deg, rgba(255,214,51,1) 0%, rgba(255,214,51,1) 49%, rgba(239,150,22,1) 100%);
        overflow: hidden;

        &:disabled {
            filter: grayscale(1);
        }
    }


</style>
